/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 轮播图左右箭头
 */
export enum ArrowE {
    left = 'left',
    right = 'right'
}

/**
 * 轮播图最小索引
 */
export const MIN_INDEX = 0;

/**
 * 自动播放轮询时间（毫秒）
 */
export const AUTO_PLAY_POLLING_TIME = 7000;

/**
 * 重新开始自动播放的时间（毫秒）
 */
export const RESTART_AUTOPLAY_TIME = 4000;

/**
 * tip每一行的字数（根据字体大小12px所得）
 */
export const PER_LINE_WORDS = 30;

/**
 * tip每一行字的高度（像素）
 */
export const PER_LINE_WORDS_HEIGHT = 20;
